export const getFirstShoppingCartFooterButtonStyle = () => ({
  borderRadius: "16px",
  borderColor: "#383838",
  color: "#383838",
  textTransform: "none",
  fontWeight: "400",
  fontFamily: "kanit",
  marginTop: "8px",
});

export const getSecondShoppingCartFooterButtonStyle = () => ({
  borderRadius: "16px",
  borderColor: "#383838",
  color: "#EAF1EA",
  background: "#383838",
  textTransform: "none",
  fontWeight: "400",
  fontFamily: "kanit",
  marginTop: "16px",
  "&:hover": {
    backgroundColor: "#505050",
  },
});
